<top-menu [showPrint]="true"></top-menu>
<loader-pane-fragment [trace]="traceNames.viewBudgetReport"></loader-pane-fragment>
<div class="wrap100">
  <div class="header-strip" *ngIf="!!budget && !closed">
    <div style="flex:1;"></div>
    <div class="actions">
      <div style="flex:1;"></div>
      <h5 class="snapshot" [matMenuTriggerFor]="snapshot">
        <span>{{ !budget?.summarySnapshots?.length ? '+ Save a snapshot' : 'Snapshots'}}</span>
        <span class="down-arrow" *ngIf="budget?.summarySnapshots?.length"></span>
      </h5>
    </div>
  </div>
  <budget-report-view 
    *ngIf="!!budget && !!budgetSummary" 
    [budget]="budget" 
    [readOnly]="readOnly || closed"
    [budgetSummary]="budgetSummary"
    [cashFlowGrid]="cashFlowGrid"
    [eventStatus]="eventStatus"
    (budgetUpdated)="saveBudget()"
  ></budget-report-view>
</div>

<mat-menu #snapshot="matMenu" xPosition="before" class="snapshot_menus">
  <h5>SNAPSHOTS</h5>
  <div class="caption" *ngIf="!budget?.summarySnapshots?.length">No snapshots</div>
  <div mat-menu-item class="item" *ngFor="let shot of budget?.summarySnapshots" (click)="openSnapshot(shot)">
    <div class="name">{{ shot.name }}</div>
    <div class="time">{{ shot.timestamp | date:'h:mma, EEE d MMM'}}</div>
  </div>
  <mat-progress-spinner *ngIf="savingSnapshot" [diameter]="25" mode="indeterminate" color="primary"></mat-progress-spinner>
  <button class="snap_item" (click)="saveSnapshot()">+ SAVE A SNAPSHOT</button>
</mat-menu>


